/**
 * Profile translations
 * Includes: Edit profile, avatar upload, nickname modification
 */
export default {
  accountManagement: 'Account management',
  termsOfUse: 'Terms of Use',
  privacyPolicy: 'Privacy Policy',
  communityGuidelines: 'Community Guidelines',
  logOut: 'Log Out',
  id: 'ID',
  enterNickname: 'Enter nickname',
  nicknameTooShort: 'Nickname must be at least 2 characters',
  nicknameTooLong: 'Nickname cannot exceed 20 characters',
  updateSuccess: 'Update successful',
  invalidImageType: 'Please select an image file',
  imageSize2MBLimit: 'Image size cannot exceed 2MB',
  imageNotSquare: 'Please upload a square image (width equals height)',
  invalidImage: 'Invalid image file',
  uploadLimitExceeded: 'Upload failed: upload limit exceeded',
  uploadDailyLimitExceeded: 'Upload failed: daily upload limit exceeded',
}
